import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [currentLang, setCurrentLang] = useState(() => {
        const saved = localStorage.getItem('blonix_lang');
        if (saved && translations[saved]) {
            return saved;
        }
        // Try to detect browser language
        const browserLang = navigator.language;
        if (translations[browserLang]) return browserLang;
        if (translations[browserLang.split('-')[0]]) return browserLang.split('-')[0];

        return 'en';
    });

    useEffect(() => {
        localStorage.setItem('blonix_lang', currentLang);
        // Optionally set html lang attribute
        document.documentElement.lang = currentLang;
    }, [currentLang]);

    const t = (path) => {
        const keys = path.split('.');
        let result = translations[currentLang];

        for (const key of keys) {
            if (result && result[key]) {
                result = result[key];
            } else {
                // Fallback to English
                let fallback = translations['en'];
                for (const fkey of keys) {
                    if (fallback && fallback[fkey]) {
                        fallback = fallback[fkey];
                    } else {
                        return path; // Key not found
                    }
                }
                return fallback;
            }
        }
        return result;
    };

    const changeLanguage = (langCode) => {
        if (translations[langCode]) {
            setCurrentLang(langCode);
        }
    };

    return (
        <LanguageContext.Provider value={{ currentLang, t, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
